import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'simpleSorter'
})

export class SimpleSorterPipe implements PipeTransform {
    public transform(value: object[], property: string): object[] {

        return value.sort((a: object, b: object) => {
            return a[property].localeCompare(b[property]);
        });
    }
}
